var exports = {
  "DB": "x04b3a21e--dc7d50--documents",
  "Fp": "x04b3a21e--dc7d50--link-container",
  "yy": "x04b3a21e--dc7d50--fullwidth",
  "nf": "x04b3a21e--dc7d50--link",
};

module.exports = exports;
